import { EntityType } from '@frontend/common';
import { DefaultBadge } from '@frontend/components/badge';
import { defaultCellClassName } from '@frontend/components/list';
import { ReactiveObjectList } from '@frontend/components/list-v2';
import { CommonMessage } from '@frontend/lang';
import { SpotExtendedClient } from '@frontend/spot/api';
import { SpotStatusBadge } from '@frontend/spot/badge';
import { SpotExtended } from '@frontend/spot/types';
import { FormattedMessage } from 'react-intl';

import { usePlatformModalHost } from '../../../modal/platform-modal-host/platform-modal-host.context';
import OverviewHeader from '../../header/overview-header';
import { useSpots } from './spots.controller';

export const Spots = () => {
    const viewProps = useSpots();
    const { openPlatformDetail } = usePlatformModalHost();
    return (
        <div className='size-lf-stretch bg-background-default inline-flex w-full flex-col items-start justify-start gap-6'>
            <OverviewHeader
                title={
                    <div className='flex gap-2'>
                        <span>{CommonMessage.OBJECTS.SPOT.DISTRI_SPOTS}</span>
                        <span>/</span>
                        <span>{CommonMessage.OBJECTS.SPOT.DISTRI_SPOTS}</span>
                    </div>
                }
            />

            <ReactiveObjectList<SpotExtended>
                key='spots-list'
                id={'spots-list'}
                fetch={(arg) => SpotExtendedClient.fetchSpotExtendeds(arg)}
                dispatch={viewProps.dispatch}
                type={EntityType.SPOT}
                onSelectElement={(obj) =>
                    openPlatformDetail({
                        entityType: EntityType.SPOT,
                        id: obj.id
                    })
                }
                columns={{
                    columns: ['name', 'address', 'num_modules', 'type', 'status'],
                    customCells: new Map([
                        [
                            'address',
                            (obj) => (
                                <td className={defaultCellClassName}>
                                    <div className='flex gap-1'>
                                        {obj.row.original.street && <span>{obj.row.original.street}</span>}
                                        {obj.row.original.number && <span>{obj.row.original.number},</span>}
                                        {obj.row.original.zip_code && <span>{obj.row.original.zip_code}</span>}
                                        {obj.row.original.city && <span>{obj.row.original.city}</span>}
                                    </div>
                                </td>
                            )
                        ],
                        [
                            'type',
                            (obj) => (
                                <td className={defaultCellClassName}>
                                    {obj.row.original.type ? (
                                        <DefaultBadge
                                            label={(obj.row.original.type.charAt(0).toUpperCase() + obj.row.original.type.slice(1)).replace(/_/g, ' ')}
                                            styles={{ container: { color: 'bg-brand-muted' } }}
                                        />
                                    ) : (
                                        <span className='text-foreground-muted'>-</span>
                                    )}
                                </td>
                            )
                        ],
                        [
                            'status',
                            (obj) => (
                                <td className={defaultCellClassName}>
                                    <SpotStatusBadge status={obj.row.original.status} />
                                </td>
                            )
                        ],
                        [
                            'num_modules',
                            (obj) => (
                                <td className={defaultCellClassName}>
                                    <DefaultBadge
                                        label={obj.row.original.num_modules}
                                        styles={{ container: { color: 'bg-background-surface' }, label: 'text-foreground-default' }}
                                    />
                                </td>
                            )
                        ]
                    ]),
                    headerOverwrite: new Map([
                        [
                            'num_modules',
                            <div
                                key='num-modules-header'
                                className='flex gap-1'>
                                <span>#</span>
                                <span>{CommonMessage.OBJECTS.MODULE.PLURAL}</span>
                            </div>
                        ],
                        [
                            'name',
                            <FormattedMessage
                                key='spots.locations.spot-name-header'
                                id='spots.locations.spot-name-header'
                                defaultMessage='distriSPOT name'
                            />
                        ]
                    ])
                }}
                activeFilter={{
                    searchKeys: ['name'],
                    displayName: new Map([
                        [
                            'name',
                            <FormattedMessage
                                key='spots.locations.spot-name-header'
                                id='spots.locations.spot-name-header'
                                defaultMessage='distriSPOT name'
                            />
                        ]
                    ])
                }}
            />
        </div>
    );
};
